import React from "react";
import { Link } from "react-router-dom";
import instagram from "../assets/instagram.svg";
import Circles from "../components/Circles";
import Button from "../components/Button";
import Nav from "../components/Nav";
import { useCurrentPage } from "../providers/CurrentPageContext";

function Results() {
  const [currentPage, setCurrentPage] = useCurrentPage();

  return (
    <section className="bg-petrol-500">
      <Nav />
      <div className="container">
        <h1 className="sm:mt-64 mt-36 px-[45px]">
          Tack för din medverkan! Hoppas vi ses i finalen på Frölunda Torg!
        </h1>
        <div className="flex w-full flex-col items-center gap-[30px] mt-auto">
          <Link to="/topplistan">
            <Button
              text="Topplistan"
              buttonClass="primary"
              // onClick={() => setCurrentPage(1)}
            />
          </Link>
          <Button
            text="Spela igen"
            buttonClass="secondary"
            onClick={() => setCurrentPage(1)}
          />
        </div>
      </div>

      <Circles color="bg-syren-300" />
    </section>
  );
}

export default Results;
